import { useCallback, useMemo } from "react";
export const useSelect = ({ data, getKey, value = [], multiple = true, onSelectionChange, }) => {
    const selectedKeysSet = useMemo(() => new Set(value), [value]);
    // 1. High-speed lookup table: Re-calculated only when source data changes
    const dataMap = useMemo(() => {
        const map = new Map();
        data.forEach((item, index) => map.set(getKey(item, index), item));
        return map;
    }, [data, getKey]);
    // 2. Derive selectedItems by looking up keys in the Map.
    // Complexity: O(m) where m is the number of selected items, rather
    // than O(n) where n is total data length.
    const selectedItems = useMemo(() => {
        const items = [];
        selectedKeysSet.forEach((key) => {
            const item = dataMap.get(key);
            if (item !== undefined) {
                items.push(item);
            }
        });
        return items;
    }, [selectedKeysSet, dataMap]);
    const select = useCallback((item, index) => {
        const key = getKey(item, index);
        let nextKeys;
        if (!multiple) {
            nextKeys = [key];
        }
        else {
            const newSet = new Set(selectedKeysSet);
            if (newSet.has(key))
                newSet.delete(key);
            else
                newSet.add(key);
            nextKeys = Array.from(newSet);
        }
        const nextItems = nextKeys
            .map((k) => dataMap.get(k))
            .filter((i) => i !== undefined);
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(nextKeys, nextItems);
    }, [getKey, multiple, onSelectionChange, dataMap, selectedKeysSet]);
    const getIsOptionSelected = useCallback((item, index) => selectedKeysSet.has(getKey(item, index)), [selectedKeysSet, getKey]);
    return {
        select,
        getIsOptionSelected,
        selectedItems,
        selectedCount: selectedKeysSet.size,
    };
};
//# sourceMappingURL=useSelect.js.map